import React from "react";
import { IoIosArrowBack } from "react-icons/io";

export default function CMHeader({ headertxt, backbtn }) {
  return (
    <>
      <div className="lg:hidden sticky top-0 left-0 w-full h-[70px] bg-white shadow-md flex items-center px-2 z-50">
        {
          backbtn && (
            <IoIosArrowBack
              className="text-base text-coalBlack p-1.5 w-9 h-9 rounded-full active:bg-blue-50 lg:hidden"
              onClick={() => {
                window.history.back();
              }}
            />
          )
        }

        <p className="text-coalBlack headingText capitalize px-2">{headertxt}</p>
      </div>
    </>
  )
}